import { render, staticRenderFns } from "./alipayConfigContent.vue?vue&type=template&id=4bd6e9a3"
import script from "./alipayConfigContent.vue?vue&type=script&lang=js"
export * from "./alipayConfigContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports